import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit, Input } from '@angular/core';
import { ReportService } from '../../../../common/services/Report.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import * as _ from 'lodash';
import { TicketService } from '../../../../common/services/Ticket.service';
import { PriorityService } from '../../../../common/services/Priority.service';
import { ServiceService } from '../../../../common/services/Service.service';
import { TicketTypeService } from '../../../../common/services/TicketType.service';
import { GroupService } from '../../../../common/services/Group.service';
import { UserService } from '../../../../common/services/User.service';
// import { timeout } from 'q';
import { cloneDeep} from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { ExportService } from 'app/common/services/Export.service';

declare var $: any;
declare var Chartist: any;

@Component({
    selector: 'report-ticket',
    templateUrl: './ticket.template.html',
    styleUrls: ['./report.component.css'],
    providers: [ReportService, TicketService, GroupService, UserService, PriorityService, ServiceService, TicketTypeService]
})



export class TicketComponent implements OnInit {
    @Input() rtype;

    public modelFilter : any = {
        filter: 'status'
    };

    public filterAssignStatus : any  = {
        filter : 'assign-status'
    }
    public options : any = {};
    public chart_type : string = 'column';
    public allStatus : Array<any> = [{id:'', text: ''}];
    public allRoom : Array<any> = [{id:'', text: ''}];
    public allAccount : Array<any> = [{id:'', text: ''}];
    public allPriority : Array<any> = [{id:'', text: ''}];
    public allService : Array<any> = [{id:'', text: ''}];
    public allType : Array<any> = [{id:'', text: ''}];
    public assignList : Array<any> = [];
    public assignList_page_divide : Array<any> = [];
    public assignList_remove_duplicate_sumup_value : Array<any> = [];
    public assignList_remove_duplicate_sumup_value_page_divide : Array<any> = [];
    public filterType : string = 'min';
    totalPage : number = 0;
    currentPage : number = 1;
    public exportData : any = [];
    public ticketList : any = [];
    public allSources : any = [];
    public searchTime1 : string = "";
    public searchTime2 : string = "";

    constructor(
        private reportService: ReportService,
        private ticketService: TicketService,
        private groupService : GroupService,
        private userService : UserService,
        private priorityService : PriorityService,
        private serviceService : ServiceService,
        private ticketTypeService : TicketTypeService,
        private toastr: ToastrService,
        private exportService : ExportService
    ) {
        this.modelFilter = {
            from: moment().add('-30', 'days').format('YYYY-MM-DD HH:mm'),
            to: moment().format('YYYY-MM-DD HH:mm')
        }
    }

    ngOnInit() {
        this.allSources = [
            { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
            { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
            { id: 'chat', text: 'Tin nhắn web' },
            {id: 'hand', text: 'Thêm mới'},
            { id: 'zalo', text: 'Zalo' },
            { id: 'email', text: 'Email' },
            { id: 'facebook', text: 'Kênh Facebook' },
            
        ]
        if(this.rtype=='ticket-status') {
            this.modelFilter['filter'] = 'status';
            this.filterAssignStatus['filter'] = 'assign-status';
            this.getStatus();
            this.loadTicket();
            this.loadAssignStatus();
        }
        if(this.rtype=='ticket-source') {
            this.modelFilter['filter'] = 'source';
            this.filterAssignStatus['filter'] = 'assign-source';
            this.loadTicket();
            this.loadAssignStatus();
        }
        
    }


    changeFilterType(type) {
        this.filterType = type;
        if(type == 'max') {
            this.getRooms();
            // this.getAccounts();
            this.getPriorities();
            this.getServices();
            this.getTypes();
            this.getStatus();
        }else {
            this.allAccount = [{id:'', text: ''}];
            delete this.modelFilter.assign_agent_ids;
            delete this.modelFilter.assign_group_ids;
            delete this.modelFilter.type_ids;
            delete this.modelFilter.service_ids;
            delete this.modelFilter.priority_ids;

            delete this.filterAssignStatus.assign_agent_ids;
            delete this.filterAssignStatus.assign_group_ids;
            delete this.filterAssignStatus.type_ids;
            delete this.filterAssignStatus.service_ids;
            delete this.filterAssignStatus.priority_ids;
        }
    }

    refreshFilter(){
        // this.allAccount = [{id:'', text: ''}];
            delete this.modelFilter.assign_agent_ids;
            delete this.modelFilter.assign_group_ids;
            delete this.modelFilter.type_ids;
            delete this.modelFilter.service_ids;
            delete this.modelFilter.priority_ids;

            delete this.filterAssignStatus.assign_agent_ids;
            delete this.filterAssignStatus.assign_group_ids;
            delete this.filterAssignStatus.type_ids;
            delete this.filterAssignStatus.service_ids;
            delete this.filterAssignStatus.priority_ids;
            this.allAccount = [{id: '', text:''}];
    }

    getStatus() {
        this.ticketService.status().subscribe(res => {
            let statusList = [];
            res.data.forEach((c: any) => {
                statusList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allStatus = statusList;
        });
    }

    getRooms() {
        this.groupService.allGroup().subscribe(res => {
            let roomList = [{id: '', text: ''}];
            res.data.forEach((c: any) => {
                roomList.push({
                    text: c.name,
                    id: c.id.toString(),
                });
            });
            this.allRoom = roomList;
        });
    }

    getAccounts(group_id) {
        if(group_id && group_id !='') {
            let where = {
                filters : JSON.stringify([
                    {
                        key: 'group_id',
                        condition : '=',
                        value : group_id
                    }
                ])
            }
            this.userService.list(where).subscribe(res => {
                let staffList = [];
                res.data.list.forEach((c: any) => {
                    staffList.push({
                        text: c.name,
                        id: c._id,
                    });
                });
                this.allAccount = staffList;
            });
        }
    }

    getTypes() {
        this.ticketTypeService.allTicketType().subscribe(res => {
            let typeList = [];
            res.data.forEach((c: any) => {
                typeList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allType = typeList;
        });
    }

    getServices() {
        this.serviceService.allService().subscribe(res => {
            let serviceList = [];
            res.data.forEach((c: any) => {
                if(c.parent_id == null){
                    serviceList.push({
                        text: c.name,
                        id: c.id,
                    });
                }
                
            });
            this.allService = serviceList;
        });
    }

    getPriorities() {
        this.priorityService.allPriority().subscribe(res => {
            let priorityList = [];
            res.data.forEach((c: any) => {
                priorityList.push({
                    text: c.name,
                    id: c.id,
                });
            });
            this.allPriority = priorityList;
        });
    }

    loadAssignStatus() {
        this.reportService.reportTicket(this.filterAssignStatus).subscribe(res => {
            this.assignList = res.data.result;
            if(this.filterAssignStatus['assign_mode'] == 'room'){
                // Trình non
                // this.assignList.forEach(e => {
                //     if(!e.data.CALL_INBOUND) e.data.CALL_INBOUND = 0;
                //     if(!e.data.CALL_OUTBOUND) e.data.CALL_OUTBOUND = 0;
                //     if(!e.data.hand) e.data.hand = 0;
                //     if(!e.data.chat) e.data.chat = 0;
                //     if(!e.data.zalo) e.data.zalo = 0;
                //     if(!e.data.email) e.data.email = 0;
                // })
                // Trình pro
                var output = this.assignList.reduce(function(accumulator, cur) {
                    var room_name = cur.room_name, found = accumulator.find(function(elem) {
                        return elem.room_name == room_name
                    });
                    if (found){
                        var obj1 = cloneDeep(found.data);
                        var obj2 = cloneDeep(cur.data);
                        // Trình non
                        // found.data.CALL_INBOUND += cur.data.CALL_INBOUND;
                        // found.data.CALL_OUTBOUND += cur.data.CALL_OUTBOUND;
                        // found.data.chat += cur.data.chat;
                        // found.data.email += cur.data.email;
                        // found.data.hand += cur.data.hand;
                        // found.data.zalo += cur.data.zalo;
                        let mergeWithSum = {}
                        let A = Object.keys(obj1)
                        let B = Object.keys(obj2)
                        if(A.length > B.length){
                            Object.keys(obj1).forEach((k, i) => {
                            if(obj2.hasOwnProperty(k)) mergeWithSum[k] = obj2[k] + obj1[k]
                            else if(B[i] !== undefined){
                                mergeWithSum[k] = obj1[k]
                                mergeWithSum[B[i]] = obj2[B[i]]
                            }  else mergeWithSum[k] =  obj1[k]
                            });
                        } else {
                            Object.keys(obj2).forEach((k, i) => {
                                if(obj1.hasOwnProperty(k)) mergeWithSum[k] = obj2[k] + obj1[k] 
                                else if(A[i] !== undefined){
                                    mergeWithSum[k] = obj2[k]
                                    mergeWithSum[A[i]] = obj1[A[i]]
                                }
                                else mergeWithSum[k] = obj2[k]
                            });
                        }
                    found.data = mergeWithSum;
                    } else accumulator.push(cur);
                    return accumulator;
                  }, []);
                  this.assignList_remove_duplicate_sumup_value = output;
                  this.totalPage = this.assignList_remove_duplicate_sumup_value.length % 10 != 0 ? Math.floor(this.assignList_remove_duplicate_sumup_value.length/10) + 1 : Math.floor(this.assignList_remove_duplicate_sumup_value.length/10);
                  var begin = (this.currentPage - 1) * 10;
                  var end = this.currentPage * 10;
                  this.assignList_remove_duplicate_sumup_value_page_divide = this.assignList_remove_duplicate_sumup_value.slice(begin, end);
            } else {
                this.totalPage = this.assignList.length % 10 != 0 ? Math.floor(this.assignList.length/10) + 1 : Math.floor(this.assignList.length/10);
                var begin = (this.currentPage - 1) * 10;
                var end = this.currentPage * 10;
                this.assignList_page_divide = this.assignList.slice(begin, end);
            }
        })
    }

    loadTicket() {
        this.reportService.reportTicket(this.modelFilter).subscribe(res => {
            this.ticketList = res.data.result;
            let data = _.map(res.data.result, e => {
                
                if(this.chart_type == 'pie') return  {
                    name: e.title + ': ' + e.count,
                    y: e.count
                };
                else return [e.title, e.count];
            })
            this.options = {
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Tổng ' + res.data.total + ' phiếu ghi' 
                    }
                },
                chart: { type: this.chart_type , height: 400, width:1250},
                title: { text: 'Tổng ' + res.data.total + ' phiếu ghi' , align : 'left', style: "font-size: 14px; padding-bottom:10px"},
                series: [{
                    name: "Phiếu ghi",
                    colorByPoint: true,
                    data: data,
                }]
            };
        })
    }

    setPage(page: number) {
        if (page <= this.totalPage) {
            if (page < 1) {
                page = 1;
            }
            if (page != this.currentPage) {
                this.currentPage = page;
                this.loadAssignStatus();
            }
        }
        else {

            page = this.totalPage;
            $('#inputPage').val(page);
            this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right'
            });
            if (page <= this.totalPage) {
                //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
                if (page < 1) {
                    page = 1;
                }
                if (page != this.currentPage) {
                    this.currentPage = page;
                    this.loadAssignStatus();
                }
            }
        }
    }

    goPage2(toPage: any) {
        toPage = parseInt(toPage);
        if (toPage && toPage > 0) {
            this.setPage(toPage);
        }
    }


    // ngAfterViewInit() {
    //     console.log($('.3csoft-datepicker'))
    //     $('.3csoft-datepicker').datepicker({ format: 'yyyy-mm-dd HH:mm' });
    //     $('.3csoft-datepicker1').datepicker({ format: 'yyyy-mm-dd HH:mm' });
    // }

    

    changeTime(type) {
        this.searchTime1 = type;
        let start :any = moment().format('YYYY-MM-DD HH:mm');;
        let end :any = moment().format('YYYY-MM-DD HH:mm');;
        switch(type) {
            case 'year' : {
                // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
                start = moment().add('-365','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'month' : {
                // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
                start = moment().add('-30','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'week' : {
                // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
                start = moment().add('-7','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'day' : {
                // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                start = moment().add('-1','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'hour' : {
                start = moment().add('-1','hours').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'minute' : {
                start = moment().add('-30','minutes').format('YYYY-MM-DD HH:mm');
                break;
            }
            default : break;
        }
        this.modelFilter['from'] = start;
        this.modelFilter['to'] = end;
        this.loadTicket();
    }

    submitFilter() {
        if(this.modelFilter.from) this.modelFilter.from = moment(this.modelFilter.from).format('YYYY-MM-DD HH:mm');
        if(this.modelFilter.to) this.modelFilter.to = moment(this.modelFilter.to).format('YYYY-MM-DD HH:mm');

        if(this.modelFilter.from) {
            this.filterAssignStatus['from'] = this.modelFilter.from;
        }
        if(this.modelFilter.to) {
            this.filterAssignStatus['to'] = this.modelFilter.to;
        }
        this.loadTicket();
        this.loadAssignStatus();
    }


    changeAssignMode(type) {
        this.currentPage = 1;
        this.filterAssignStatus['assign_mode'] = type;
        this.loadAssignStatus();
    }
    
    changeAssignTime(type) {
        this.searchTime2 = type;
        let start :any = moment().format('YYYY-MM-DD HH:mm');;
        let end :any = moment().format('YYYY-MM-DD HH:mm');;
        switch(type) {
            case 'year' : {
                // start = moment().startOf('year').format('YYYY-MM-DD HH:mm');
                start = moment().add('-365','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'month' : {
                // start = moment().startOf('month').format('YYYY-MM-DD HH:mm');
                start = moment().add('-30','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'week' : {
                // start = moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm');
                start = moment().add('-7','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'day' : {
                // start = moment().startOf('day').format('YYYY-MM-DD HH:mm');
                start = moment().add('-1','days').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'hour' : {
                start = moment().add('-1','hours').format('YYYY-MM-DD HH:mm');
                break;
            }
            case 'minute' : {
                start = moment().add('-30','minutes').format('YYYY-MM-DD HH:mm');
                break;
            }
            default : break;
        }
        this.filterAssignStatus['from'] = start;
        this.filterAssignStatus['to'] = end;
        this.loadAssignStatus();
    }

    public changeUser(e: any): void {
        this.filterAssignStatus['assign_agent_ids'] = e.value;
        this.modelFilter['assign_agent_ids'] = e.value;
    }

    public changeRoom(e: any): void {
        this.filterAssignStatus['assign_group_ids'] = e.value;
        this.modelFilter['assign_group_ids'] = e.value;
        this.getAccounts(e.value);
    }
    public changeService(e: any): void {
        this.filterAssignStatus['service_ids'] = e.value;
        this.modelFilter['service_ids'] = e.value;
    }

    public changeType(e: any): void {
        this.filterAssignStatus['type_ids'] = e.value;
        this.modelFilter['type_ids'] = e.value;
    }
    public changePriority(e: any): void {
        this.filterAssignStatus['priority_ids'] = e.value;
        this.modelFilter['priority_ids'] = e.value;
    }


    export() {
        this.exportData = [];
        if(this.filterAssignStatus['filter'] == 'assign-status'){
            this.ticketList.forEach(data =>{
                var data_json : any = {};
                data_json['STT'] = this.ticketList.indexOf(data) + 1;
                data_json['Trạng thái'] = data.title;
                data_json['Số lượng'] = data.count;
                this.exportData.push(data_json);
            })
            this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi theo trạng thái ' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
        } else if(this.filterAssignStatus['filter'] == 'assign-source'){
            this.ticketList.forEach(data =>{
                var data_json : any = {};
                data_json['STT'] = this.ticketList.indexOf(data) + 1;
                data_json['Nguồn'] = data.title;
                data_json['Số lượng'] = data.count;
                this.exportData.push(data_json);
            })
            this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi theo nguồn ' + moment(new Date()).format("YYYY-MM-DD HH-mm"));
        } 
    }

    exportDetail() {
        this.exportData = [];
        
        if(this.filterAssignStatus['filter'] == 'assign-status'){
            if(this.filterAssignStatus.assign_mode == 'room'){
                this.assignList_remove_duplicate_sumup_value.forEach(data => {
                    var data_json : any = {};
                    data_json['Phòng ban'] = data.room_name;
                    this.allStatus.forEach((e) => {
                        if(e.text != "") data_json[e.text] = data.data[e.id] ? data.data[e.id] : 0;
                    })
                    this.exportData.push(data_json);
                })
                this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi chi tiết phòng ban theo trạng thái ' + new Date());
            } else {
                this.assignList.forEach(data => {
                    var data_json : any = {};
                    data_json['Chuyên viên'] = data.user_name;
                    this.allStatus.forEach((e) => {
                        if(e.text != "") data_json[e.text] = data.data[e.id] ? data.data[e.id] : 0;
                    })
                    this.exportData.push(data_json);
                })
                this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi chi tiết chuyên viên theo trạng thái ' + new Date());
            }
        } else if(this.filterAssignStatus['filter'] == 'assign-source'){
            if(this.filterAssignStatus.assign_mode == 'room'){
                this.assignList_remove_duplicate_sumup_value.forEach(data => {
                    var data_json : any = {};
                    data_json['Phòng ban'] = data.room_name;
                    this.allSources.forEach((e) => {
                        if(e.text != "") data_json[e.text] = data.data[e.id] ? data.data[e.id] : 0;
                    })
                    this.exportData.push(data_json);
                })
                this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi chi tiết phòng ban theo nguồn ' + new Date());
            } else {
                this.assignList.forEach(data => {
                    var data_json : any = {};
                    data_json['Chuyên viên'] = data.user_name;
                    this.allSources.forEach((e) => {
                        if(e.text != "") data_json[e.text] = data.data[e.id] ? data.data[e.id] : 0;
                    })
                    this.exportData.push(data_json);
                })
                this.exportService.exportExcel(this.exportData, 'Báo cáo phiếu ghi chi tiết chuyên viên theo nguồn ' + new Date());
            }
        } 
    }
}





// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/report/ticket.component.ts